import React, { useState } from 'react';
import { Form, Button, Col, Row, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";



// Define styles
const containerStyle = {
  marginTop: '20px',
  marginLeft: '0px',
  maxWidth: '700px',
  padding: '20px',
  border: '1px solid #ced4da',
  borderRadius: '0.25rem',
  backgroundColor: '#f8f9fa',
 boxShadow :'0 0 10px rgba(0, 0, 0, 0.1)',
};

const formGroupStyle = {
  marginBottom: '15px',
};

const selectStyle = {
  borderColor: '#ced4da',
  borderRadius: '0.25rem',
};


const labelStyle = {
  marginBottom: '0',
};

const SalesComparisonForm = () => {
  // State to manage Account Tags visibility
  const [showTags, setShowTags] = useState(false);

  // Toggle visibility of Account Tags options
  const handleAccountTagsChange = (e) => {
    if (e.target.value === "show") {
      setShowTags(true);
    } else {
      setShowTags(false);
    }
  };

  return (
    <Container style={containerStyle}>
      <Form id="sales-comparison-form" action="/submit-report" method="post">
        <fieldset>
        <h2 className="text-left mb-4 text-dark">Parameters</h2>

          {/* Current Start Date */}
          <Form.Group as={Row} controlId="sales-comparison-current-start-date" style={formGroupStyle}>
            <Form.Label column sm={3} style={labelStyle} title="Please choose a start date to report on">
              Current Start Date <span className="text-danger">*</span>
            </Form.Label>
            <Col sm={9}>
              <Form.Control 
                type="date" 
                name="current_start_date" 
                required 
                defaultValue="2024-07-01" 
                style={selectStyle}
              />
            </Col>
          </Form.Group>

          {/* Current End Date */}
          <Form.Group as={Row} controlId="sales-comparison-current-end-date" style={formGroupStyle}>
            <Form.Label column sm={3} style={labelStyle} title="Please choose an end date to report on">
              Current End Date <span className="text-danger">*</span>
            </Form.Label>
            <Col sm={9}>
              <Form.Control 
                type="date" 
                name="current_end_date" 
                required 
                defaultValue="2024-07-31" 
                style={selectStyle}
              />
            </Col>
          </Form.Group>

          {/* Previous Start Date */}
          <Form.Group as={Row} controlId="sales-comparison-previous-start-date" style={formGroupStyle}>
            <Form.Label column sm={3} style={labelStyle} title="Please choose a start date to report on">
              Previous Start Date <span className="text-danger">*</span>
            </Form.Label>
            <Col sm={9}>
              <Form.Control 
                type="date" 
                name="previous_start_date" 
                required 
                defaultValue="2024-06-01" 
                style={selectStyle}
              />
            </Col>
          </Form.Group>

          {/* Previous End Date */}
          <Form.Group as={Row} controlId="sales-comparison-previous-end-date" style={formGroupStyle}>
            <Form.Label column sm={3} style={labelStyle} title="Please choose an end date to report on">
              Previous End Date <span className="text-danger">*</span>
            </Form.Label>
            <Col sm={9}>
              <Form.Control 
                type="date" 
                name="previous_end_date" 
                required 
                defaultValue="2024-06-30" 
                style={selectStyle}
              />
            </Col>
          </Form.Group>

          {/* Accounts */}
          <Form.Group as={Row} controlId="sales_comparison_practice" style={formGroupStyle}>
            <Form.Label column sm={3} style={labelStyle} title="Please choose an account to limit the report to">
              Accounts
            </Form.Label>
            <Col sm={9}>
              <Form.Control 
                as="select" 
                name="practice"
                style={selectStyle}
              >
                <option value="">All</option>
                <option value="71159">ALL SAINTS DENTAL</option>
                <option value="137334">Andrew Lee (Diu Resh)</option>
                {/* Add other options as needed */}
              </Form.Control>
              <Form.Check
                type="checkbox"
                id="include_closed"
                name="include_closed"
                label="Include Closed"
                style={{ marginTop: '10px' }}
              />
            </Col>
          </Form.Group>

          {/* Account Tags */}
          <Form.Group as={Row} controlId="report_sales_comparison_account_tags" style={formGroupStyle}>
            <Form.Label column sm={3} style={labelStyle} title="Select tags to filter report">
              Account Tags
            </Form.Label>
            <Col sm={9}>
              <Form.Control 
                as="select" 
                name="tags" 
                onChange={handleAccountTagsChange}
                style={selectStyle}
              >
                <option value="">No filter</option>
                <option value="show">Show Tags</option>
                {/* Add other options as needed */}
              </Form.Control>
              {showTags && (
                <div style={{ marginTop: '10px' }}>
                  <Form.Check
                    type="checkbox"
                    id="tag_a-practices"
                    name="tags"
                    label="a-practices"
                  />
                  <Form.Check
                    type="checkbox"
                    id="tag_bhandal"
                    name="tags"
                    label="bhandal"
                  />
                  {/* Add other tags as needed */}
                </div>
              )}
            </Col>
          </Form.Group>

          {/* Include Finance Charges */}
          <Form.Group as={Row} style={formGroupStyle}>
            <Col sm={3}>
              <Form.Label>&nbsp;</Form.Label>
            </Col>
            <Col sm={9}>
              <Form.Check
                type="checkbox"
                id="report_sales_comparison_finance_charges"
                name="finance_charges"
                label="Include Finance Charges?"
              />
            </Col>
          </Form.Group>

          {/* Subtotal By */}
          <Form.Group as={Row} controlId="sales_comparison_subtotal" style={formGroupStyle}>
            <Form.Label column sm={3} style={labelStyle} title="Please choose how to subtotal the report">
              Subtotal By <span className="text-danger">*</span>
            </Form.Label>
            <Col sm={9}>
              <Form.Control 
                as="select" 
                name="subtotal" 
                required
                style={selectStyle}
              >
                <option value="">Account</option>
                <option value="provider">Provider</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Format */}
          <Form.Group as={Row} controlId="sales_comparison_format" style={formGroupStyle}>
            <Form.Label column sm={3} style={labelStyle} title="Please choose a display format">
              Format <span className="text-danger">*</span>
            </Form.Label>
            <Col sm={9}>
              <Form.Control 
                as="select" 
                name="format" 
                required
                style={selectStyle}
              >
                <option value="">Select format</option>
                <option value="pdf">PDF</option>
                <option value="excel">Excel</option>
                {/* Add other formats as needed */}
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Submit Button */}
          <Form.Group as={Row}>
                   <Col sm={{ span: 8, offset: 4 }}>
                     <Link to="/Addcomparison">
                       <Button
                         id="pay-per-task-submit"
                         type="button"
                         variant="primary"
                         className="w-100 mt-2"
                         style={{
                           backgroundColor: '#004aad',
                           borderColor: '#004aad',
                           marginTop: '10px',
                         }}
                       >
                         Run
                       </Button>
                     </Link>
                   </Col>
                  </Form.Group>
                 </fieldset>
      </Form>
    </Container>
  );
};

export default SalesComparisonForm;
